




































import SuggestedBaseCostInfo from './SuggestedBaseCostInfo.vue'
import { trackEvent, SEGMENT_EVENTS } from '@/analytics/segment'

function priceTooLow(input) {
  return !input || parseInt(input) === 0
}
function priceTooBig(input) {
  return parseInt(input) > 9999999999
}

export default {
  components: {
    SuggestedBaseCostInfo
  },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    carrierId: { type: Number, required: true },
    orderId: { type: Number, required: false, default: 0 },
    suggestedBaseCost: { type: Number, default: 0 },
    isRelevant: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      price: null,
      showPriceTooLow: false,
      showPriceTooBig: false,
      priceValidator: [
        {
          isInvalid: () => this.showPriceTooLow,
          errorMessage: this.$t('marketPlace.requestModal.priceIndication')
        },
        {
          isInvalid: () => this.showPriceTooBig,
          errorMessage: this.$t('marketPlace.requestModal.priceIndicationTooBig')
        }
      ]
    }
  },
  methods: {
    handleClickConfirm() {
      trackEvent(SEGMENT_EVENTS.MAO_REQUEST_SENT, {
        carrierId: this.carrierId,
        isRelevant: this.isRelevant,
        orderId: this.orderId
      })

      this.showPriceTooLow = priceTooLow(this.price)
      this.showPriceTooBig = priceTooBig(this.price)
      if (this.showPriceTooLow || this.showPriceTooBig) return

      this.$emit('submit', this.price, this.suggestedBaseCost)
    },
    async handleShown() {
      this.setFocusOnInput()
    },
    setFocusOnInput() {
      this.$refs.priceInput.$el.querySelector('input').focus()
    }
  }
}
